/* istanbul ignore file */
import { convertDatePtBr } from 'utils/dateFormatter';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';
import { getEnvValue } from 'config/enviroment';
import { ALERTA, MSG_TAMANHO_ARQUIVO_NAO_SUPORTADO, ENUM_TIPO_LAYOUT_RELATORIO_DOWNLOAD } from 'utils/consts';

export const converterByteToMb = size => {
  const kilobytes = 1024; //Kilobytes
  let tamanho = size / kilobytes;
  tamanho = tamanho * 1;
  tamanho = tamanho / kilobytes;
  return tamanho.toFixed(2);
};

// VERIFICA SE O TAMANHO DE TODOS OS ARQUIVOS PASSA DO VALOR MÁXIMO PERMITIDO
export const calcularMb = (tamanhoArquivoNovo = 0, todosArquivos = [], tamanhoMaximo = 10) => {
  const tamanhoArquivoNovoMb = parseFloat(converterByteToMb(tamanhoArquivoNovo));
  const retorno = { isValid: true, soma: tamanhoArquivoNovoMb };

  for (const i in todosArquivos) {
    retorno.soma += parseFloat(todosArquivos[i].tamanhoArquivo);
  }
  if (retorno.soma > tamanhoMaximo) {
    fetchNotificationApp(MSG_TAMANHO_ARQUIVO_NAO_SUPORTADO, '', ALERTA.ERRO);
    retorno.isValid = false;
    return retorno;
  }
  return retorno;
};

export const openFileBase64 = file => {
  /* RECEBE UM ARQUIVO EM BA64 E EXIBE EM UMA NOVA GUIA DO NAVEGADOR */
  const pdfWindow = window.open('');
  if (pdfWindow)
    pdfWindow.document.write(
      `<iframe width='100%' height='100%' src='data:application/pdf;base64, ${encodeURI(file)}'></iframe>`
    );
};

export const downloadFileBase64 = base64 => {
  const a = document.createElement('a');
  a.href = 'data:application/octet-stream;base64,' + base64;
  a.download = 'documentName.pdf';
  a.click();
};

export const convertBase64 = async file => {
  /* RECEBE UM ARQUIVO E RETORNA EM BASE64 */
  if (!file) return null;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader?.result?.replace('data:application/pdf;base64,', ''));
    reader.onerror = error => reject(error);
  });
};

export function downloadFile(urlDownload) {
  const baseUrl = `${getEnvValue('URL_API')}${urlDownload}`;
  document.getElementById('download-file').src = baseUrl;
}

export const downloadFileCsv = (arq, arqNome = 'Arquivo') => {
  const downloadLink = document.createElement('a');
  downloadLink.target = '_blank';
  downloadLink.download = `${arqNome}.csv`;
  const blob = new Blob([arq], { type: 'application/csv' });
  const URL = window.URL || window.webkitURL;
  const downloadUrl = URL.createObjectURL(blob);
  downloadLink.href = downloadUrl;
  document.body.append(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(downloadUrl);
};

const _getFiltroExibirRelatorio = filtro => {
  const dataInicio = convertDatePtBr(filtro?.DataInicio) || '';
  const dataFim = convertDatePtBr(filtro?.DataFim) || '';
  const tipoPeriodo = filtro?.tipoPeriodo || 'Dia';
  return `<p class="titulo">FILTRO: Período (${tipoPeriodo}) ${dataInicio} - ${dataFim}</p>`;
};

export function printCanvas(
  filtro,
  idCanvas = 'GraficoPizzaComponenteCanva',
  tipoRelatorio = '',
  posicaoPage = ENUM_TIPO_LAYOUT_RELATORIO_DOWNLOAD.PAISAGEM
) {
  const dataUrl = document.getElementById(idCanvas).toDataURL();

  const altura = window.screen.height;
  const largura = window.screen.width;

  if (posicaoPage === ENUM_TIPO_LAYOUT_RELATORIO_DOWNLOAD.PAISAGEM) {
    const css = '@page { size: landscape; }',
      head = document.head || document.getElementsByTagName('head')[0],
      styleRetrato = document.createElement('style');

    styleRetrato.type = 'text/css';
    styleRetrato.media = 'print';

    if (styleRetrato.styleSheet) {
      styleRetrato.styleSheet.cssText = css;
    } else {
      styleRetrato.appendChild(document.createTextNode(css));
    }

    head.appendChild(styleRetrato);
  }

  let style = '<style>';
  style += '.titulo {width: 100%;font: 20px Calibri; }';
  style += 'body { font: 20px Calibri; text-align: center; }';
  style += '</style>';

  let windowContent = '<!DOCTYPE html>';
  windowContent += style;
  windowContent += '<html>';
  windowContent += '<head><title>Relatório FAS</title></head>';
  windowContent += '<body>';
  windowContent += `<p>${tipoRelatorio ? 'Relatório por ' + tipoRelatorio : ''}</p>`;
  windowContent += `<h2>${_getFiltroExibirRelatorio(filtro)}</h2>`;
  windowContent += '<img src="' + dataUrl + '">';
  windowContent += '</body>';
  windowContent += '</html>';

  const printWin = window.open('', '', `width=${largura},height=${altura}`);
  printWin.document.open();
  printWin.document.write(windowContent);

  printWin.document.addEventListener(
    'load',
    function () {
      printWin.focus();
      printWin.print();
      printWin.document.close();
      printWin.close();
    },
    true
  );
}

export const downloadFileHtmlToPdf = (
  htmlContent,
  titulo,
  posicaoPage = ENUM_TIPO_LAYOUT_RELATORIO_DOWNLOAD.PAISAGEM,
  funcFinish = () => {}
) => {
  const altura = window.screen.height;
  const largura = window.screen.width;

  if (posicaoPage === ENUM_TIPO_LAYOUT_RELATORIO_DOWNLOAD.PAISAGEM) {
    const css = '@page { size: landscape; }',
      head = document.head || document.getElementsByTagName('head')[0],
      styleRetrato = document.createElement('style');

    styleRetrato.type = 'text/css';
    styleRetrato.media = 'print';

    if (styleRetrato.styleSheet) {
      styleRetrato.styleSheet.cssText = css;
    } else {
      styleRetrato.appendChild(document.createTextNode(css));
    }

    head.appendChild(styleRetrato);
  }

  try {
    const printWin = window.open(titulo, '', `width=${largura},height=${altura}`);
    printWin.document.open();
    printWin.document.write(htmlContent);

    printWin.document.addEventListener(
      'load',
      function () {
        printWin.focus();
        printWin.print();
        printWin.document.close();
        printWin.close();
      },
      true
    );
  } catch {
    const headerHtml = htmlContent.substring(0, 15);
    const contentHtml = htmlContent.substring(15, htmlContent?.length);
    const sprint = '<script>window.print();</script>';

    const newHtml = `${headerHtml}${sprint}${contentHtml}`;
    document.getElementById('download-file').src = `data:text/html;charset=utf-8,${escape(newHtml)}`;
  }

  funcFinish();
};
